import { iOnCallRequest } from '~/domain/interfaces/models/OnCallRequest';
import { OnCallRequestTypes } from '~/domain/interfaces/redux/onCallRequest/types';
import { OnCallRequestActions } from './actions';

export const initialState: iOnCallRequest = {
  overview: {
    CLOSED: 0,
    MONITORING: 0,
    WAITING: 0,
    PROGRESS: 0,
    REPORTING: 0,
  },
  loading: false,
  records: [],
  metadata: {
    offset: 0,
    limit: 0,
    total: 0,
  },
};

const reducer = (
  state = initialState,
  action: OnCallRequestActions,
): iOnCallRequest => {
  switch (action.type) {
    case OnCallRequestTypes.LIST:
      return { ...state, loading: true };
    case OnCallRequestTypes.LIST_FAILED:
      return { ...state, loading: false };
    case OnCallRequestTypes.LIST_SUCCESS: {
      return {
        loading: false,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
